import { Injectable } from '@angular/core';

import { Action, Reducer } from '@olympus/ngx-shared';

import { ConfigService } from '../../services/config';
import { ElectronService } from '../../services/electron/electron.service';

export enum ElectronActionType {
  INITIALIZE = 'initialize',
}

@Injectable({
  providedIn: 'root',
})
export class ElectronReducer implements Reducer {
  private readonly _configService: ConfigService;

  private _electronService: ElectronService;

  public reduce(action: Action): void {
    if (action.type === ElectronActionType.INITIALIZE && this._configService.isElectron) {
      this._electronService = new ElectronService();
      setTimeout(() => {
        this._electronService.checkForUpdates();
      }, 2000);
    }
  }
}
